import 'babel-polyfill';
import Vue from 'vue'
// 局部引入ant-design-Vue  1.7版本日期选择器及国际化注入
import { DatePicker,ConfigProvider,Icon } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
// import "ant-design-vue/dist/antd.less";
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import i18n from './lang' // internationalization

import '@/styles/index.scss' // global css
import '@/styles/table.scss'
import '@/styles/gen-index.scss' //代码生成的css
import "@/assets/iconfont/iconfont.css";
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
import App from './App'
import store from './store'
import router from './router'
import directive from './directive' //directive
import ECharts from 'vue-echarts'
import * as echarts from "echarts";
import versionTood from '@/libs/versionUpdate'
versionTood.isNewVersion();
// 引入全局请求方法
import { putActionParam,postParamAction,postAction, getAction, putAction, deleteAction, downloadFileByA, downFile, downPostFile, downloadFile } from './api/action'
Vue.prototype.$http = {
    putActionParam: putActionParam,
    postParamAction: postParamAction,
    postAction: postAction,
    getAction: getAction,
    putAction: putAction,
    deleteAction: deleteAction,
    downloadFileByA: downloadFileByA,
    downFile: downFile,
    downloadFile: downloadFile,
    downPostFile: downPostFile
}
// 引入全局接口
import interFace from './interface/interface';
Vue.prototype.$interface = interFace;
// 引入全局枚举
import Enum from './enums/commonEnum';
Vue.prototype.$enum = Enum;

// 引入版本控制
import config from './utils/config';
Vue.prototype.$config = config;

// 引入全局正则
import RegExp from './RegExp/RegExp';
Vue.prototype.$RegExp = RegExp;


/*
导出指令
*/
import './filter'
/*
导出挂载方法
*/


// 文件上传组件
import FileUpload from "@/components/FileUpload"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"

Vue.component('FileUpload', FileUpload)
Vue.component('ImageUpload', ImageUpload)
Vue.component('ImagePreview', ImagePreview)

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import "./mount"
import {
  resetForm,
  addDateRange,
  handleTree
} from '@/utils/ruoyi'
Vue.prototype.addDateRange = addDateRange
Vue.prototype.handleTree = handleTree
import Pagination from "@/components/Pagination";
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar"
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
import "echarts";
//引入v-chart组件
Vue.component('v-chart', ECharts)

Vue.use(Avue);

Vue.use(DatePicker);

Vue.use(ConfigProvider);

Vue.use(Icon);

//引入查询企业公共组件
import enterpriseSearch from "@/components/common/enterpriseSearch";
Vue.component('enterpriseSearch', enterpriseSearch)

import chinaJson from './assets/js/map/json/china.json'
echarts.registerMap('china', {
  geoJSON: chinaJson
})

import * as filters from './filters' // global filters
import * as formatter from '@/utils/formatter'
import {empty,deepClone, isEmptyObject} from '@/utils'
Vue.prototype.$empty = empty
Vue.prototype.$deepClone = deepClone
Vue.prototype.$isEmptyObject = isEmptyObject

Vue.prototype.resetForm = resetForm



Vue.prototype.$formatter = formatter

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */


Vue.use(directive)
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false



Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
import { getIe8n } from "@/utils/auth";
Vue.prototype.$getIe8n = getIe8n;


let $vue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})

export default $vue



